import React from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import ExpandCollapseBox from 'Components/ExpandCollapseBox'
import CitySettingsTable from './Components/CitySettingsTable'

import {
  updateCitiesSettings,
  updateCountriesDefaultSettings,
} from '../../../../gql'

import { showReduxModal } from '../../../../../../Reducers/UI/actions'
import {
  MINIMUM_MISSION_LIMIT,
  WEEKLY_MISSION_LIMIT,
  CAMPAIGN_COSTS,
  CITY_SETTINGS_HEADERS,
} from '../../../../constants'
import { checkIsFlyerPack } from './Components/CitySettingsTable/utils'

import styles from './styles.js'

const CitySettings = ({ classes, ...props }) => {
  const dispatch = useDispatch()

  const validateCitySettings = data => {
    let valid = true

    data.forEach(city => {
      Object.entries(city).forEach(([key, value]) => {
        if (key === MINIMUM_MISSION_LIMIT || key === WEEKLY_MISSION_LIMIT) {
          if (!value && value !== null) {
            valid = false
          }
        }
      })
    })

    return valid
  }

  const handleSaveCitySettings = async data => {
    const floatKeys = CAMPAIGN_COSTS.map(option => option.key)
    const citySettingsKeys = [
      ...CITY_SETTINGS_HEADERS.map(header => header.key),
      'id',
    ]

    if (!validateCitySettings(data)) {
      dispatch(
        showReduxModal({
          title: 'Cannot save',
          onConfirm: () => {},
          children: (
            <div style={{ textAlign: 'center' }}>
              Mission related values cannot be set to 0.
            </div>
          ),
          confirmLabel: 'OK',
          hideCancel: true,
        }),
      )
      return
    }

    const mappedData = data.map(city => {
      return Object.entries(city).reduce((acc, [key, value]) => {
        const isFlyerPack = checkIsFlyerPack(key)
        return citySettingsKeys.includes(key)
          ? {
              ...acc,
              [key]:
                floatKeys.includes(key) && value
                  ? Number(value.toFixed(2))
                  : isFlyerPack
                  ? Number(value.value)
                    ? Number(value.value)
                    : null
                  : value,
            }
          : acc
      }, {})
    })

    const { h2hActiveCities, d2dActiveCities } = mappedData.reduce(
      (acc, item) => {
        if (item.enabledChannelPreciseLocations) {
          acc.h2hActiveCities.push(item)
        }

        if (item.enabledChannelLetterbox) {
          acc.d2dActiveCities.push(item)
        }

        return acc
      },
      { h2hActiveCities: [], d2dActiveCities: [] },
    )
    let updateCountryData = props.countrySettings
    const shouldDisableH2H = !h2hActiveCities.length
    const shouldDisableD2D = !d2dActiveCities.length

    if (shouldDisableH2H || shouldDisableD2D) {
      updateCountryData = {
        ...props.countrySettings,
        enabledChannelPreciseLocations: shouldDisableH2H
          ? false
          : props.countrySettings.enabledChannelPreciseLocations,
        enabledChannelLetterbox: shouldDisableD2D
          ? false
          : props.countrySettings.enabledChannelLetterbox,
      }

      await updateCountriesDefaultSettings({
        ...updateCountryData,
        id: props.countryId,
      })
    }

    const response = await updateCitiesSettings({
      nodes: mappedData,
    })
    const {
      data: { updateCitiesSettings: status },
    } = await response.json()

    props.refetch()
    return status
  }

  return (
    <Box>
      <ExpandCollapseBox title={'City Settings'}>
        <Box className={classes.subTitle}>
          <Typography>
            If you want specific values for certain cities, you can edit them
            here.
          </Typography>
          <Typography>
            0 = cost or limit is zero. Blank = default country value will be
            used.
          </Typography>
        </Box>
        <CitySettingsTable
          title={'City Settings'}
          onSave={handleSaveCitySettings}
          {...props}
        />
      </ExpandCollapseBox>
    </Box>
  )
}

export default injectStyles(styles)(CitySettings)
